module.exports = __webpack_public_path__ + "img/background.e88dd9b6.png";